import * as actions from './BalanceSheetActions';

const initialState = {
  YearOptions: [],
};

const blankClientItem = {
  PrincipalAgeOptions: [],
  SpouseAgeOptions: [],
  OwnerOptions: [],
  Items: [],
  ProjectedItems: [],
  is_initialized: false,
  year: `'${moment().format('YY')}-'${moment()
    .add(1, 'years')
    .format('YY')}`,
  errors: [],
  owners: null,
};

const BalanceSheet = (state = initialState, action) => {
  switch (action.type) {
    case actions.RECEIVE_DATA:
      const owner_options = action.resp_data.OwnerOptions;
      return Object.assign({}, state, {
        YearOptions: action.resp_data.YearOptions,
        [action.clientId]: {
          ...blankClientItem,
          ...state[action.clientId],
          PrincipalAgeOptions: action.resp_data.PrincipalAgeOptions,
          SpouseAgeOptions: action.resp_data.SpouseAgeOptions,
          OwnerOptions: owner_options,
          BalanceSheet: action.resp_data.BalanceSheet,
          owners: owner_options.filter(oo => action.owners.includes(oo)),
          is_initialized: true,
        },
      });
    case actions.SET_ERRORS:
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          errors: action.errors,
        },
      });

    default:
      return state;
  }
};

export default BalanceSheet;
